import React, { useState } from "react";
import { Button } from "@mui/material";
import styles from "./StoryTellerContent.module.scss";
import { AddItemModal } from "../AddCharacterModal/AddItemModal";
import {
  useCreateProfileStoryOptionMutation,
  useGetProfileStoriesQuery,
} from "@/store/rtk-api/books.api";
import {
  getButtonLabel,
  getCategoryIdByType,
  getDataByType,
  renderCards,
} from "../../helperForStoryTeller";

type Props = {
  type: string;
};

export const StoryTellerContent = ({ type }: Props) => {
  const [isAddItemModalOpen, setIsAddItemModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [optionName, setOptionName] = useState("");
  const [optionDescription, setOptionDescription] = useState("");

  const handleToggleModal = () => {
    setIsAddItemModalOpen((prev) => !prev);
    setOptionName("");
    setOptionDescription("");
  };

  const { data: profileStories } = useGetProfileStoriesQuery({});
  const [createOption] = useCreateProfileStoryOptionMutation();

  const data = getDataByType(profileStories, type);

  const handleAddCharacter = async () => {
    if (!selectedFile || !optionName) return;

    const categoryId = getCategoryIdByType(profileStories, type);

    try {
      const formData = new FormData();
      formData.append("categoryId", categoryId);
      formData.append("optionName", optionName);
      formData.append("description", optionDescription);
      formData.append("imgFile", selectedFile);

      console.log(formData);

      await createOption(formData).unwrap();
      handleToggleModal();
    } catch (error) {
      console.error("Failed to create option:", error);
    }
  };

  return (
    <div className={styles.content}>
      <Button
        sx={{
          textTransform: "capitalize",
          height: "44px",
          width: "174px",
          backgroundColor: "#008000",
          borderRadius: "12px",
          "&:hover": {
            backgroundColor: "#008000",
          },
        }}
        variant="contained"
        onClick={handleToggleModal}
      >
        {getButtonLabel(type)}
      </Button>

      <div className={styles.items}>
        {renderCards(data, type)}

        {isAddItemModalOpen && (
          <AddItemModal
            type={type}
            isOpenAddItemModal={isAddItemModalOpen}
            setIsOpenAddItemModal={setIsAddItemModalOpen}
            onAddCharacter={handleAddCharacter}
            optionName={optionName}
            setOptionName={setOptionName}
            setSelectedFile={setSelectedFile}
            optionDescription={optionDescription}
            setOptionDescription={setOptionDescription}
          />
        )}
      </div>
    </div>
  );
};

